import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '@/db/schema'
import { logout } from '@/auth/oauth'

const tabs = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/trends', label: 'Trends' },
  { to: '/calendar', label: 'Calendar' },
  { to: '/dayofweek', label: 'Day of Week' },
  { to: '/workouts', label: 'Workouts' },
  { to: '/export', label: 'Export' },
]

export default function Layout() {
  const profile = useLiveQuery(() => db.profile.get('me'), [])
  const nav = useNavigate()

  const handleLogout = () => {
    logout()
    nav('/login', { replace: true })
  }

  return (
    <div className="min-h-full flex flex-col">
      <header className="bg-white border-b border-stone-200">
        <div className="max-w-7xl w-full mx-auto px-6 pt-6 pb-3 flex items-center gap-4">
          <button
            type="button"
            onClick={() => nav('/')}
            className="rounded-xl flex-shrink-0 transition-transform active:scale-95 hover:opacity-90"
            aria-label="Home"
          >
            <img src="/logo-256.png" alt="" className="w-12 h-12 rounded-xl" />
          </button>
          <div className="text-2xl font-semibold leading-tight truncate">
            {greetingFor(profile?.first_name)}
          </div>
        </div>
        <nav className="max-w-md sm:max-w-7xl w-full mx-auto px-4 pb-3">
          <div className="grid grid-cols-3 gap-1.5 sm:flex sm:flex-wrap sm:justify-center sm:gap-1">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                className={({ isActive }) =>
                  clsx(
                    'px-3 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap text-center',
                    isActive
                      ? 'bg-brand/25 text-brand-fg font-medium'
                      : 'text-stone-600 hover:bg-stone-100',
                  )
                }
              >
                {t.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main className="flex-1 px-6 py-6 max-w-7xl w-full mx-auto">
        <Outlet />
      </main>
      <footer className="border-t border-stone-200 px-6 py-6 text-center text-xs text-stone-500 space-y-3">
        <button
          onClick={handleLogout}
          className="text-stone-500 hover:text-stone-900 underline underline-offset-4 decoration-stone-300 hover:decoration-stone-500 transition-colors"
        >
          Sign out
        </button>
        <div>
          by{' '}
          <a
            href="https://bijansabet.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-600 hover:text-brand-fg transition-colors"
          >
            @bijan
          </a>{' '}
          ·{' '}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-600 hover:text-brand-fg transition-colors"
          >
            Privacy
          </a>{' '}
          · Designed in Nantucket, Massachusetts · © 2026
        </div>
      </footer>
    </div>
  )
}

function greetingFor(firstName?: string): string {
  const h = new Date().getHours()
  let prefix = 'Good evening'
  if (h < 5) prefix = 'Hello' // late-night/early-morning catch-all
  else if (h < 12) prefix = 'Good morning'
  else if (h < 18) prefix = 'Good afternoon'
  return firstName ? `${prefix}, ${firstName}` : prefix
}

